// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import TerceraSeparatorTemplate from '@front/templates/TerceraSeparatorTemplate.html';
import { ControlsTypes } from '../UtilsClasses/FactoryConstants';
import { Control } from './Control';
import { NewContextMenuItemType } from '@shared/utils/ContextMenuUtils';
export class TerceraSeparator extends Control {
    constructor() {
        super();
    }
    getType() {
        return ControlsTypes.TerceraSeparator;
    }
    getContextMenuItem() {
        return { type: NewContextMenuItemType.Separator };
    }
}
Control.extendWith(TerceraSeparator, {
    template: TerceraSeparatorTemplate,
    data: () => ({ isVertical: false })
});
